import { IMG } from "@/data/site";

export const SERVICE_PAGES = {
  photo: {
    slug: "photo-editing",
    metaTitle: "Real Estate Photo Editing Services — HDR & Flambient | VCONTRACTZ",
    metaDesc: "Premium real estate photo editing: HDR, flambient, window pulls, perspective and colour correction for photographers and agencies worldwide.",
    overline: "Service 01 — Photo Editing",
    title: ["REAL ESTATE", "PHOTO EDITING."],
    intro:
      "Professional enhancement for interior and exterior property photography — true-to-life light, colour and perspective, matched precisely to your style.",
    heroImg: IMG.interiorAfter,
    heroAlt: "Flambient-edited luxury living room — real estate photo editing by VCONTRACTZ",
    includes: [
      "HDR Blending",
      "Flambient Editing",
      "Ambient Blending",
      "Exposure Correction",
      "White Balance",
      "Colour Correction",
      "Window Pull",
      "Perspective Correction",
      "Vertical Correction",
      "Natural Retouching",
    ],
    approach: [
      "Every account begins with a style profile. Send us finished examples of your work and our editors calibrate to your grade — contrast, warmth, saturation and the way you handle windows.",
      "From single exposures to five-frame flambient brackets, each image is hand-blended, corrected and reviewed before delivery. Nothing leaves the studio until it looks like your best day of shooting.",
    ],
    sliders: [
      {
        title: "Flambient Interior Enhancement",
        caption: "Warm ambient capture — colour balanced, exposure blended, screen & fireplace refined",
        before: IMG.interiorBefore,
        after: IMG.interiorAfter,
        testId: "sp-compare-flambient",
      },
      {
        title: "Bedroom HDR & Window Pull",
        caption: "Dim mixed-light capture — white balanced, windows pulled, shadows lifted",
        before: IMG.bedroomBefore,
        after: IMG.bedroomAfter,
        testId: "sp-compare-bedroom",
      },
      {
        title: "Window Pull & Colour",
        caption: "Dim ambient capture — window view pulled, white balance & colour refined",
        before: IMG.windowPullBefore,
        after: IMG.windowPullAfter,
        testId: "sp-compare-windowpull",
      },
    ],
  },
  panorama: {
    slug: "panorama-editing",
    metaTitle: "Panorama & 360° Editing Services | VCONTRACTZ",
    metaDesc: "Seamless 360° panorama stitching, exposure balancing, nadir cleanup and virtual-tour-ready output for immersive property presentation.",
    overline: "Service 02 — Panorama & 360°",
    title: ["PANORAMA &", "360° EDITING."],
    intro:
      "Seamless panoramic post-production designed to preserve perspective, atmosphere and architectural detail — ready for immersive virtual tours.",
    heroImg: IMG.panoImage,
    heroAlt: "Modern luxury villa panorama — 360 panorama editing by VCONTRACTZ",
    includes: [
      "360° Panorama Stitching",
      "Exposure Balancing",
      "Colour Correction",
      "Perspective Correction",
      "Nadir Cleanup",
      "Window Enhancement",
      "Sky Replacement",
      "Object Removal",
      "Virtual-Tour-Ready Output",
    ],
    approach: [
      "Stitching is only the beginning. We balance exposure across every frame, straighten architectural lines, clean the nadir and refine windows and skies until the seam disappears.",
      "Output is delivered tour-ready — correctly projected, levelled and graded to sit naturally inside your preferred virtual-tour platform.",
    ],
    pano: true,
  },
  video: {
    slug: "video-editing",
    metaTitle: "Real Estate Video Editing Services | VCONTRACTZ",
    metaDesc: "Cinematic real estate video editing: property walkthroughs, drone footage, social reels, colour grading, titles and motion graphics.",
    overline: "Service 03 — Video Editing",
    title: ["REAL ESTATE", "VIDEO EDITING."],
    intro:
      "Raw footage transformed into cinematic property marketing films — graded, paced and finished to make every property feel extraordinary.",
    video: true,
    includes: [
      "Property Walkthroughs",
      "Cinematic Reels",
      "Drone Footage Editing",
      "Social Media Videos",
      "Colour Grading",
      "Music Synchronisation",
      "Transitions",
      "Titles",
      "Motion Graphics",
      "Vertical / Horizontal Formats",
    ],
    approach: [
      "We cut for the way buyers actually watch — a strong opening frame, a rhythm that holds attention, and movement that lets the architecture breathe.",
      "Every film is colour-graded to your brand, scored and synchronised to music, and delivered in horizontal, vertical and square formats for every channel.",
    ],
  },
};
